import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'techDoc.recurrentProblem.title',
        defaultMessage: 'Recurrent Problems'
    },
    EMPTY: {
        id: 'techDoc.recurrentProblem.empty',
        defaultMessage: 'There is no recurrent problem defined'
    },
    TABLE_PROBLEM_NUMBER: {
        id: 'techDoc.recurrentProblem.table.problemNumber',
        defaultMessage: 'Problem number'
    },
    TABLE_PROBLEM_TITLE: {
        id: 'techDoc.recurrentProblem.table.problemTitle',
        defaultMessage: 'Problem title'
    },
    TABLE_ATTACHMENT: {
        id: 'techDoc.recurrentProblem.table.attachment',
        defaultMessage: 'Attachment'
    },
    TABLE_LAST_UPDATE: {
        id: 'techDoc.recurrentProblem.table.lastUpdate',
        defaultMessage: 'Last update'
    },
    SELECT_COUNTRY: {
        id: 'techDoc.recurrentProblem.selectCountry',
        defaultMessage: 'Select a country'
    },
});

export default messages;
